import { GameState } from '../game/GameState';
import { DataRegistry } from './DataRegistry';
import { PlayerPreferences } from './PlayerPreferences';
import { TutorialManager } from './TutorialManager';

export function startNewCampaign(scenarioId: string, playerFactionId: string) {
  const registry = DataRegistry.instance;
  const scenario = registry.scenarios[scenarioId] ?? Object.values(registry.scenarios)[0];
  if (!scenario) throw new Error('No scenario data loaded.');
  GameState.instance.initFromScenario(registry, scenario, playerFactionId);
  if (PlayerPreferences.instance.value.tutorialEnabled) TutorialManager.instance.reset();
}
